import React, { useState } from 'react';
import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import DataMethodLink from '../dataMethodLink/dataMethodLink';
import Chart1 from './chart1/chart1';
import Chart2 from './chart2/chart2';

// styles
import './chart4Wrapper.scss';

const Chart4Wrapper = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleChangeTab = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <div className="chart4wrapper">
      <ChartTitleIntro number={4} title="Ab welchem Einkommen zählt man zu den obersten Einkommensgruppen?">
        In den folgenden interaktiven Grafiken sind die Einkommen von Haushalten ersichtlich, die zur Spitzengruppe zählen. Wenn die Schwelle der
        Top-10%-Einkommen bei 133'000 Franken liegt, dann gehören jene Haushalte zu den Top-10%, die so viel oder mehr verdienen. Grafik 4.1 erlaubt
        einen interkantonalen Vergleich der (nominalen) Einkommensschwellen. Die Schwellen werden in Grafik 4.2 zu den Preisen des jüngsten
        verfügbaren Jahres (real) angegeben, um einen Vergleich über die Zeit zu ermöglichen. Hier erfahren Sie mehr zu <DataMethodLink />.
      </ChartTitleIntro>
      <div className="charttabs">
        <div className="charttabs-tabs">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => handleChangeTab(0)}>
            4.1 INTERKANTONALER VERGLEICH DER NOMINALEN EINKOMMENSSCHWELLEN
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => handleChangeTab(1)}>
            4.2 ENTWICKLUNG DER REALEN EINKOMMENSSCHWELLEN
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">4.1 INTERKANTONALER VERGLEICH DER NOMINALEN EINKOMMENSSCHWELLEN</div>
            <Chart1 />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">4.2 ENTWICKLUNG DER REALEN EINKOMMENSSCHWELLEN</div>
            <Chart2 />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chart4Wrapper;
